// extracted by mini-css-extract-plugin
export default {"container":"InfoPage_container__DqCW7","infoItem":"InfoPage_infoItem__yNokS"};